export const financialReducers = {
    paymentCompleteSlice(state, action) {
        state.paymentComplete = action.payload;
    },
    checkoutListingSlice(state, action) {
        state.checkoutListing = action.payload;
    },
    refundListingSlice(state, action) {
        state.refundListing = action.payload;
    },
};
